import React, { useState } from 'react';
import './CollapsibleCode.css';

interface CollapsibleCodeProps {
  code: string;
  language?: string;
}

const CollapsibleCode: React.FC<CollapsibleCodeProps> = ({ code, language = 'python' }) => {
  const [isCollapsed, setIsCollapsed] = useState(true); // Default to collapsed
  
  // Count lines to show in preview
  const lines = code.split('\n');
  const lineCount = lines.length;
  const previewLines = lines.slice(0, 10).join('\n');
  
  return (
    <div className="collapsible-code">
      <div className="code-header">
        <span className="code-language">{language}</span>
        <span className="code-lines">{lineCount} lines</span>
        <button 
          className="collapse-button"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          {isCollapsed ? '▶ Show Code' : '▼ Hide Code'}
        </button>
      </div>
      
      {!isCollapsed ? (
        <pre className="code-block">
          <code>{code}</code>
        </pre>
      ) : (
        <div className="code-preview">
          <pre className="code-block preview">
            <code>{previewLines}</code>
          </pre>
          <div className="code-fade">...</div>
        </div>
      )}
    </div>
  );
};

export default CollapsibleCode;